import React, { useState, useEffect } from "react";
import { Modal, Form, Tabs, message } from "antd";
import { connect } from "react-redux";

import { selectDataForFixedSelectList } from "../../../fixed_list/actions/index";
import { handleUserInfo } from "../../actions/index";
import { Session } from "../../../../business";
import { api_fetch } from "../../../../V2/utils/HttpRequest/request";
import { PersonalInformation } from "./personalInformation";
import { AddressInformation } from "./addressInformation";
import { BankInformation } from "./bankInformation";
import { AccessDataInformation } from "./accessDataInformation";
import { PlataformConfiguration } from "./plataformConfiguration";

const { TabPane } = Tabs;

const EditUserInfo = ({
    isVisible,
    showEditUserInfoModel,
    selectDataForFixedSelectList,
    fixedList,
    getProfilePhoto,
    form,
}) => {
    const [loading, setLoading] = useState(false);

    const [userData, setUserData] = useState({
        fullName: undefined,
        nameToUse: undefined,
        email: undefined,
        nif: undefined,
        habilityAcademic: undefined,
        birthDate: undefined,
        gender: undefined,
        phone: undefined,
        celphone: undefined,
        country: undefined,
        district: undefined,
        residence: undefined,
        parish: undefined,
        street: undefined,
        postalCode4: undefined,
        postalCode3: undefined,
        door: undefined,
        piso: undefined,
        bank: undefined,
        iban: undefined,
        nib: undefined,
        username: undefined,
    });

    const [imageUrl, setImageUrl] = useState(undefined);

    const [lingua, setLingua] = useState(undefined);
    const [linguaOld, setLinguaOld] = useState(undefined);
    const [listLingua, setListLingua] = useState(undefined);

    const { getFieldDecorator } = form;

    const { district, parish, residence, birthDate, bank, nib, iban, username } = userData;

    useEffect(() => {
        const loadData = async () => {
            const result = await api_fetch({
                endPoint: "Gestor/execQuery.php",
                method: "POST",
                params: {
                    query: `buscar_linguas`,
                },
            });

            if (result.status === "SUCCESS") {
                setListLingua(result?.response.result);
            }
        };
        if (isVisible) {
            loadData();
        }
    }, [isVisible]);

    useEffect(() => {
        (async () => {
            if (isVisible) {
                return;
            }

            const response = await handleUserInfo({ accao: "get_info" });
            if (response && response.status === "sucess" && response.data) {
                setValuesToFields(response.data);
                getProfilePhoto(response.data.foto_perfil);

                selectDataForFixedSelectList(
                    {
                        query: "pais",
                        _valor_campo_: response?.data?.idpais,
                    },
                    "pais"
                );
            } else {
                message.error(response.message);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isVisible]);

    useEffect(() => {
        if (district) {
            selectDataForFixedSelectList(
                {
                    query: "distrito",
                    _valor_campo_: district,
                },
                "distrito"
            );
        }
    }, [district, selectDataForFixedSelectList]);

    useEffect(() => {
        if (residence) {
            selectDataForFixedSelectList(
                {
                    query: "concelho",
                    _valor_campo_: residence,
                },
                "concelho"
            );
        }
    }, [residence, selectDataForFixedSelectList]);

    useEffect(() => {
        if (parish) {
            selectDataForFixedSelectList(
                {
                    query: "freguesia",
                    _valor_campo_: parish,
                },
                "freguesia"
            );
        }
    }, [parish, selectDataForFixedSelectList]);

    const setValuesToFields = (response) => {
        if (response) {
            setUserData({
                username: response.username || undefined,
                fullName: response.nome_completo || undefined,
                nameToUse: response.nome || undefined,
                piso: response.andar || undefined,
                street: response.arruamento || undefined,
                bank: response.bank || undefined,
                birthDate: response.data_nascimento || undefined,
                district: response.distrito || undefined,
                email: response.email || undefined,
                habilityAcademic: response.habilitacao || undefined,
                iban: response.iban || undefined,
                residence: response.id_distconc || undefined,
                parish: response.id_freguesia || undefined,
                country: response.idpais || undefined,
                nib: response.nib || undefined,
                nif: response.nif || undefined,
                door: response.porta || undefined,
                postalCode4: response.c_postal4 || undefined,
                postalCode3: response.c_postal3 || undefined,
                gender: response.sexo || undefined,
                phone: response.tlf || undefined,
                celphone: response.tlm || undefined,
            });

            setImageUrl(response.foto_perfil || undefined);
            setLingua(response.lingua || undefined);
            setLinguaOld(response.lingua || undefined);
        }
    };

    const handleChange = (info) => {
        getBase64(info.file.originFileObj, (imageUrl) => {
            setImageUrl(imageUrl);
            setLoading(false);
        });
    };

    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener("load", () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    function handleOnChangeBirthDate(value) {
        setUserData((state) => {
            return { ...state, birthDate: value };
        });
    }

    function hanldeSaveUserInfo() {
        form.validateFields(async (err, values) => {
            if (!err) {
                setLoading(true);
                let requestBody = {};
                if (imageUrl) requestBody = { ...requestBody, foto_perfil: imageUrl };
                if (birthDate)
                    requestBody = {
                        ...requestBody,
                        data_nascimento: birthDate,
                    };
                Object.entries(values).forEach(([key, val]) => {
                    if (val && val.trim()) {
                        requestBody = {
                            ...requestBody,
                            [key]: val.trim(),
                        };
                    }
                });

                const response = await handleUserInfo({
                    accao: "editar_info",
                    dados: JSON.stringify(requestBody),
                });

                setLoading(false);
                if (response.status === "sucess") {
                    const isChangedLanguage = linguaOld !== values.lingua;
                    setValuesToFields(response.data.user);

                    getProfilePhoto(response.data.user.foto_perfil);
                    if (response && response.data && response.data.token) {
                        const user = Session.getAll();
                        if (user && user.username && user.username !== response.data.user.username) {
                            Session.update({
                                username: response.data.user.username,
                                name: response.data.user.nome,
                                token: response.data.token,
                            });
                        }
                    }
                    message.success(response.message);
                    showEditUserInfoModel();
                    if (isChangedLanguage) {
                        window.location.reload();
                    }
                } else {
                    message.error(response.message);
                }
            } else {
                const requeredFields = [
                    { name: "nome", label: "Nome a utilizar" },
                    { name: "nome_completo", label: "Nome completo" },
                ];

                requeredFields.forEach((item) => {
                    if (err[item.name]) {
                        message.error(`Campo obrigatório: ${item.label}`);
                    }
                });
            }
        });
    }

    return (
        <Modal
            centered
            confirmLoading={loading}
            destroyOnClose
            title="Editar informações"
            visible={isVisible}
            width="70%"
            bodyStyle={{ minHeight: 480 }}
            onCancel={() => showEditUserInfoModel()}
            onOk={() => hanldeSaveUserInfo()}
        >
            <Tabs defaultActiveKey={"1"}>
                <TabPane tab="Informação pessoal" key="1">
                    <PersonalInformation
                        userData={userData}
                        getFieldDecorator={getFieldDecorator}
                        handleChange={handleChange}
                        imageUrl={imageUrl}
                        loading={loading}
                        onChangeBirthDate={handleOnChangeBirthDate}
                    />
                </TabPane>
                <TabPane tab="Morada" key="2">
                    <AddressInformation
                        userData={userData}
                        district={district}
                        fixedList={fixedList}
                        getFieldDecorator={getFieldDecorator}
                        selectDataForFixedSelectList={selectDataForFixedSelectList}
                    />
                </TabPane>
                <TabPane tab="Informação bancária" key="3">
                    <BankInformation
                        bank={bank}
                        fixedList={fixedList}
                        getFieldDecorator={getFieldDecorator}
                        iban={iban}
                        nib={nib}
                    />
                </TabPane>
                <TabPane tab="Dados de acesso" key="4">
                    <AccessDataInformation getFieldDecorator={getFieldDecorator} username={username} />
                </TabPane>
                <TabPane tab="Configurações da plataforma" key="5">
                    <PlataformConfiguration
                        getFieldDecorator={getFieldDecorator}
                        lingua={lingua}
                        listLingua={listLingua}
                        setLingua={setLingua}
                    />
                </TabPane>
            </Tabs>
        </Modal>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        listOfItems: state.dynamicList.domain.byId,
        fixedList: state.fixedList.domain.byId,
    };
};

const mapDispatchToProps = {
    selectDataForFixedSelectList,
};

const WrappedNewContributor = Form.create({ name: "edit_user" })(EditUserInfo);

export default connect(mapStateToProps, mapDispatchToProps)(WrappedNewContributor);
